'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @class RichTextContent
  * A content item consisting of HTML text created
  * with a rich text editor.
  * @prop {string} html - the HTML to display
  */
var RichTextContent = function (_Component) {
  _inherits(RichTextContent, _Component);

  function RichTextContent() {
    _classCallCheck(this, RichTextContent);

    return _possibleConstructorReturn(this, (RichTextContent.__proto__ || Object.getPrototypeOf(RichTextContent)).apply(this, arguments));
  }

  _createClass(RichTextContent, [{
    key: 'render',

    /** @function
     * Renders the Rich Text Content component.
     */
    value: function render() {
      var html = { __html: this.props.html };
      return _react2.default.createElement('div', { dangerouslySetInnerHTML: html });
    }
  }]);

  return RichTextContent;
}(_react.Component);

exports.default = RichTextContent;


RichTextContent.propTypes = {
  html: _propTypes2.default.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/content/rich-text-content.js
// module id = 1320
// module chunks = 0